import React, { Component } from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import { monthOptions, yearOptions } from "../../config";
import { configDaily, SAMPLE_DATA, configMonitoring } from "../config";
import { removeNullFields } from "../../../../../common/mapper";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { HttpStatus } from "../../../../../common/Constants";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";

class ROCrossSellingReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: null,
            year: null,
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            // month: monthOptions.find(item => item.value === currentDate.getMonth()),
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            tableConfig: configMonitoring,
        }));
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(prevProps.search, this.props.search)) {
            this.fetchData();
        }
    };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async () => {
        try {
            this.props.triggerLoading();
            let dataKodeCabang = this.props.search;
            if (this.props.isAllSelected) {
                dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
            }

            const request = removeNullFields({
                kodeCabangList: dataKodeCabang,
                month: this.state.month?.value,
                year: this.state.year?.value,
            });
            

            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikROCrossSelling,
                menuName: "Dashboard Koordinator - Laporan Statistik Repeat Order dan Cross Selling",
                setError: this.props.setError,
                args: request,
            });
            console.log(res);
            

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: res.data.data || []
                }));
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log("errors: ", error);
        }
    };

    render() {
        return (
            <>
                <FlexView style={{ gap: "20px", alignItems: "center" }}>
                    <SimpleDDL
                        id="select_options_month"
                        box="search"
                        name="month"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, { name }) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, { name }) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{ marginBottom: "15px" }}
                        onClick={this.fetchData}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                />
            </>
        );
    };
}

export default ROCrossSellingReport;